<template>
  <b-dropdown id="select-language">
    <template slot="button-content">
      <country-flag :country="country" size="normal" />
      {{ countryName }}
    </template>

    <b-dropdown-item @click="selectCountry('Português')">
      <country-flag country="br" size="normal" />
      {{ this.$t('dashboard.portugues') }}
    </b-dropdown-item>

    <b-dropdown-item @click="selectCountry('English')">
      <country-flag country="us" size="normal" />
      {{ this.$t('dashboard.ingles') }}
    </b-dropdown-item>

    <b-dropdown-item @click="selectCountry('Español')">
      <country-flag country="es" size="normal" />
      {{ this.$t('dashboard.espanhol') }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import CountryFlag from 'vue-country-flag';
import { mapFields } from 'vuex-map-fields';
import api from '../../../services/api';
import EventBus from '../../../eventBus';

export default {
  components: {
    CountryFlag,
  },

  data() {
    return {
      countryName: 'Português',
      userAuth: null,
    };
  },

  computed: {
    ...mapFields('settings', ['country']),
  },

  props: {
    isLogin: Boolean,
  },

  methods: {
    async selectCountry(country) {
      if (country === 'Português') {
        this.countryName = country;
        this.country = 'br';
      } else if (country === 'English') {
        this.countryName = country;
        this.country = 'us';
      } else {
        this.countryName = country;
        this.country = 'es';
      }

      this.$i18n.locale = this.country;
      EventBus.$emit('changedLanguage', true);

      if (!this.isLogin) {
        await api.put(
          '/user/country',
          { country: this.country },
          { headers: { 'x-access-token': this.userAuth.token } },
        );

        if (this.$store.state.actions.myActionId === '0') {
          this.$store.state.actions.myActionName = this.$t(
            'menu.allActionsLabel',
          );
        }

        if (this.$store.state.actions.actionGroupData._id == null) {
          this.$store.state.actions.actionGroupData.name = this.$t(
            'actionList.actionTable.noClassifiedLabel',
          );
        }

        if (this.$store.state.actions.favouriteGroup._id == null) {
          this.$store.state.actions.favouriteGroup.name = this.$t(
            'actionList.actionTable.noClassifiedLabel',
          );
        }
        for (
          let i = 0;
          i < this.$store.state.actions.allGroups.length;
          i += 1
        ) {
          if (this.$store.state.actions.allGroups[i]._id == null) {
            this.$store.state.actions.allGroups[i].name = this.$t(
              'actionList.actionTable.noClassifiedLabel',
            );
          }
        }
      }

      return this.country;
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    if (this.country === 'br') {
      this.countryName = 'Português';
    } else if (this.country === 'us') {
      this.countryName = 'English';
    } else {
      this.countryName = 'Español';
    }
  },
};
</script>

<style>
button#select-language__BV_toggle_ {
  background: #fff;
  border: none;
}

span.flag.f-br.normal-flag {
  margin-bottom: -14px;
}

span.flag.f-us.normal-flag {
  margin-bottom: -14px;
}

span.flag.f-co.normal-flag {
  margin-bottom: -14px;
}

span.flag.f-es.normal-flag {
  margin-bottom: -14px;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/dropdown-country/index.vue